import { isApp } from '@/utils/constants';
import coreStore, { useLazyStoreInstanceOrCreate } from './core';
import firstInitStore from './firstInit';
import userStore from './user';
import initStore from './init';
import sessionStore from './session';
import modalStore from './modal';
import agentStore from './agent';
import sessionIDListStore from './sessionIDList';
import showDataStore from './showData';
import performanceStore from './performance';
import inputStore from './input';
import historyStore from './history';
import unreadMsgStore from './unreadMsg';
import compareStore from './compare';
import { handleResponse } from '@/utils';
import * as MOCK_JSON from './mock/mock_init.constant';

if ((process.env.environment === 'test' || process.env.environment === 'uat') && !isApp && !window?.isLiveChatSDK?.()) {
  import('./mock');
}

export const useAllStore = () => {
  coreStore.setStore('initStore', initStore);
  coreStore.setStore('sessionStore', sessionStore);
  coreStore.setStore('modalStore', modalStore);
  coreStore.setStore('agentStore', agentStore);
  coreStore.setStore('sessionIDListStore', sessionIDListStore);
  coreStore.setStore('showDataStore', showDataStore);
  coreStore.setStore('performanceStore', performanceStore);
  coreStore.setStore('userStore', userStore);
  coreStore.setStore('inputStore', inputStore);
  coreStore.setStore('historyStore', historyStore);
  coreStore.setStore('unreadMsgStore', unreadMsgStore);
  coreStore.setStore('compareStore', compareStore);

  inputStore.COLLECT_FIRSTINIT_STORE();

  // 标识store装载完毕
  coreStore.updateFullStore();
};

export {
  userStore,
  initStore,
  sessionStore,
  modalStore,
  agentStore,
  sessionIDListStore,
  showDataStore,
  performanceStore,
  inputStore,
  historyStore,
  firstInitStore,
  unreadMsgStore,
  compareStore,
};
